import { AppNode } from '../types';

/**
 * 获取最后一个节点
 * @param nodes 节点数组
 * @returns 最后一个节点或 undefined（如果数组为空）
 */
export const getLastNode = (nodes: AppNode[]): AppNode | undefined => {
  if (nodes.length === 0) {
    return undefined;
  }
  return nodes[nodes.length - 1];
};
